import * as commands from "./commands";
import * as queries from "./queries";
import produce from "immer";

let initialState = {};

const notes = (state = initialState, action = { type: "" }) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case commands.CREATE_BORROWER_NOTE_REQUEST: {
        let borrowerNotes = draft[action.dataSent.BorrowerId];
        if (borrowerNotes) {
          borrowerNotes.sending = true;
          borrowerNotes.error = "";
        } else draft[action.dataSent.BorrowerId] = { sending: true, error: "" };

        break;
      }

      case commands.CREATE_BORROWER_NOTE_SUCCESS: {
        let borrowerNotes = draft[action.dataSent.BorrowerId];

        borrowerNotes.sending = false;
        borrowerNotes.sent = true;
        if (borrowerNotes.data)
          borrowerNotes.data = [
            newPost(action.dataSent),
            ...borrowerNotes.data,
          ];
        else borrowerNotes.data = newPost(action.dataSent);

        break;
      }

      case commands.CREATE_BORROWER_NOTE_ERROR:
        draft[action.dataSent.BorrowerId].sending = false;
        draft[action.dataSent.BorrowerId].sent = false;
        draft[action.dataSent.BorrowerId].error = "error creating note";
        break;

      case queries.BORROWER_NOTE_GET_REQUEST: {
        const borrowerNote = draft[action.additionalData];
        if (borrowerNote) {
          borrowerNote.fetching = true;
          borrowerNote.error = "";
        } else draft[action.additionalData] = { fetching: true };
        break;
      }

      case queries.BORROWER_NOTE_GET_SUCCESS: {
        const borrower = action.response;
        const borrowerNotes = draft[action.additionalData];
        const filteredNotes = borrower.Notes.filter(
          (x) => x.Type === "Regular",
        );
        borrowerNotes.fetching = false;
        borrowerNotes.fetched = true;
        borrowerNotes.data = filteredNotes;
        break;
      }

      case queries.BORROWER_NOTE_GET_ERROR:
        draft[action.additionalData].fetching = false;
        draft[action.additionalData].error = "error loading notes";
        break;

      /////////////////////////////////// investor notes

      case commands.CREATE_INVESTOR_NOTE_REQUEST: {
        let investorNotes = draft[action.dataSent.InvestorId];
        if (investorNotes) {
          investorNotes.sending = true;
          investorNotes.error = "";
        } else draft[action.dataSent.InvestorId] = { sending: true, error: "" };
        break;
      }

      case commands.CREATE_INVESTOR_NOTE_SUCCESS:
        draft[action.dataSent.InvestorId].sending = false;
        draft[action.dataSent.InvestorId].sent = true;
        if (draft[action.dataSent.InvestorId].data)
          draft[action.dataSent.InvestorId].data = [
            newPost(action.dataSent),
            ...draft[action.dataSent.InvestorId].data,
          ];
        else
          draft[action.dataSent.InvestorId].data = [newPost(action.dataSent)];
        break;

      case commands.CREATE_INVESTOR_NOTE_ERROR:
        if (draft[action.dataSent.InvestorId]) {
          draft[action.dataSent.InvestorId].sending = false;
          draft[action.dataSent.InvestorId].sent = false;
          draft[action.dataSent.InvestorId].error = "error creating note";
        } else
          draft[action.dataSent.InvestorId] = {
            sending: false,
            sent: false,
            error: "error creating note",
          };
        break;

      case queries.INVESTOR_NOTE_GET_REQUEST:
        if (draft[action.additionalData]) {
          draft[action.additionalData].fetching = true;
          draft[action.additionalData].error = "";
        } else draft[action.additionalData] = { fetching: true };
        break;

      case queries.INVESTOR_NOTE_GET_SUCCESS: {
        const investor = action.response;
        const filteredNotes = investor.Notes.filter(
          (x) => x.Type === "Regular",
        );
        draft[action.additionalData].fetching = false;
        draft[action.additionalData].fetched = true;
        draft[action.additionalData].data = filteredNotes;
        break;
      }

      case queries.INVESTOR_NOTE_GET_ERROR:
        draft[action.additionalData].fetching = false;
        draft[action.additionalData].error = "error loading notes";
        break;
      default:
        return draft;
    }
  });
};

export default notes;

function newPost(post) {
  return {
    Id: new Date().valueOf(),
    Text: post.Text,
    Author: "You",
    Created: new Date(),
  };
}
